module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseText__container', _vm.className]
  }, [(_vm.icon) ? _c('i', {
    class: ['BaseText__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BaseText",
    class: {
      'BaseText_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_c('input', {
    staticClass: "BaseText__input",
    attrs: {
      "type": _vm.password ? 'password' : 'text',
      "required": "",
      "autofocus": _vm.autofocus ? true : false
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enter()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "BaseText__bar"
  }), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseText__label"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e47cc1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseText.vue
// module id = 492
// module chunks = 1